export default {
  messageId: 'g1-environment',
  bannerTag: 'NON_PRODUCTION',
  descriptionTag: 'NON_PRODUCTION_DESCRIPTION',
  type: 'account',
  additionalAttributes: [],
};
